var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Article "+_vm._s(_vm.$route.params.articleid)+"\n  "),_c('pre',{domProps:{"textContent":_vm._s(_vm.article)}})])}
var staticRenderFns = []

export { render, staticRenderFns }